<template>
  <el-breadcrumb
    class="breadcrumb"
    separator-class="el-icon-arrow-right"
  >
    <!-- <el-breadcrumb-item>{{ $t('route.console') }}</el-breadcrumb-item> -->
    <el-breadcrumb-item
      v-for="(item, index) in list"
      :key="index"
    >
      {{ item() }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>

export default {
  computed: {
    list() {
      return this.$route.meta.breadcrumb || [];
    },
  },
};
</script>

<style>

</style>

<i18n src="./i18n.json"></i18n>
